import { useEffect } from "react";
import { useAdminPageTitle } from "@/contexts/admin-page-title-context";

const SettingsPage = () => {
  const { setPageTitle } = useAdminPageTitle();

  useEffect(() => {
    setPageTitle("Settings");
  }, [setPageTitle]);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-[#202020]">Settings</h1>
    </div>
  );
};

export default SettingsPage;